import { Outlet } from "react-router-dom";
import { UnauthorizedPage } from "../pages/app/UnauthorizedPage";
import { useAuth } from "./AuthContext";
import { PermissionValue } from "./permissions";
import { hasPermission } from "./rolePermissions";

type PermissionRouteProps = {
  permission: PermissionValue;
  children?: React.ReactNode;
};

// Route-level counterpart to the sidebar's permission filter: hiding a menu item
// isn't enough, since the URL can still be typed directly. Wraps either a single
// element (children) or a group of nested routes (renders <Outlet />).
export const PermissionRoute = ({ permission, children }: PermissionRouteProps) => {
  const { user } = useAuth();

  if (!hasPermission(user?.role, permission)) {
    return <UnauthorizedPage />;
  }

  return children ? <>{children}</> : <Outlet />;
};
